<script lang="ts">
	import { Modal, Button, Text, Container, Icon } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';

	export let showModal = false;
	export let actionType: 'run' | 'enable' = 'run';
	export let originalSceneName: string = '';
	export let onConfirm: () => void = () => {};
	export let onCancel: () => void = () => {};

	$: titleKey =
		actionType === 'run'
			? 'duplicate_scene_warning_title'
			: 'duplicate_scene_activation_warning_title';

	$: headingKey =
		actionType === 'run'
			? 'duplicate_scene_warning_heading'
			: 'duplicate_scene_activation_warning_heading';

	$: messageKey =
		actionType === 'run'
			? 'duplicate_scene_warning_message'
			: 'duplicate_scene_activation_warning_message';

	$: confirmButtonKey = actionType === 'run' ? 'button_run_anyway' : 'button_enable_anyway';

	$: titleText = actionType === 'run' ? 'Run Duplicate Scene?' : 'Enable Duplicate Scene?';

	$: messageText =
		actionType === 'run'
			? 'You are about to run a duplicate scene. This may lead to unexpected behavior as the same actions might be triggered multiple times.'
			: 'You are about to enable a duplicate scene. This may lead to unexpected behavior as the same automation might be triggered multiple times.';

	$: confirmButtonText = actionType === 'run' ? 'Run Anyway' : 'Enable Anyway';

	const handleClose = () => {
		onCancel();
	};

	const handleConfirm = () => {
		onConfirm();
	};

	const handleCancel = () => {
		onCancel();
	};
</script>

<Modal {showModal} on:close={handleClose} title={$format(titleKey, { default: titleText })}>
	<Container slot="content" padding="0">
		<div class="d-flex flex-direction-column align-items-center">
			<Icon size="xxl" icon="fa-solid fa-triangle-exclamation" class="text-warning mb-xs" />
			<Text class="text-bold text-center mb-s" styleType="controls-large">
				{$format(headingKey, { default: 'Duplicate Scene Warning' })}
			</Text>
			<Text class="width-full text-center">
				{$format(messageKey, { default: messageText })}
			</Text>
			{#if originalSceneName}
				<Text class="width-full text-center mt-s text-color-muted">
					{$format('duplicate_scene_original_info', {
						values: { original_name: originalSceneName },
						default: `Original scene: "${originalSceneName}"`,
					})}
				</Text>
			{/if}
		</div>
	</Container>

	<div slot="footer" class="d-flex justify-content-end">
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{ sm: 'm' }}
			variant="secondary"
			on:click={handleCancel}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			variant="danger"
			responsiveSize={{ sm: 'm' }}
			on:click={handleConfirm}
		>
			{$format(confirmButtonKey, { default: confirmButtonText })}
		</Button>
	</div>
</Modal>
